import React from "react";
import { useParams } from "react-router-dom";
import Footer from "../Shared/Footer";
import AllBrandProducts from "./AllBrandProducts";

const BrandProducts = () => {
  const { brand_slug } = useParams();
  return (
    <>
      <main>
        <section className="my-10">
          <h1 className="text-center text-primary font-bold text-2xl">
            All Products Of {brand_slug}
          </h1>
          <AllBrandProducts brand_slug={brand_slug}></AllBrandProducts>
        </section>
      </main>
      <Footer></Footer>
    </>
  );
};

export default BrandProducts;
